import {frontpageGuidelinesLW, defaultGuidelinesLW} from './LWModerationGuidelinesContent'

export const getFrontpageGuidelines = () => frontpageGuidelinesLW
export const getDefaultGuidelines = () => defaultGuidelinesLW

